export default __webpack_public_path__ + "static/media/tg.0befc019.svg";